import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { ApplicationState } from "../store";
import { Cart, ProductsData, UserData, UserProfile } from "../models/types";
import { fetchMenu } from "../store/menu/action";
import { changeLanguage } from "../store/language/action";
import { getStatus, logoutUser } from "../store/users/action";
import { searchText } from "../store/products/action";
import { ThunkDispatch } from "redux-thunk";
import { AnyAction } from "redux";
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import TextField from '@material-ui/core/TextField';
import Badge from '@material-ui/core/Badge';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import Menu from '@material-ui/core/Menu';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import SearchIcon from '@material-ui/icons/Search';
import AccountCircle from '@material-ui/icons/AccountCircle';
import MoreIcon from '@material-ui/icons/MoreVert';
import { Autocomplete } from "@material-ui/lab";
import { Box, Grid, Hidden } from "@material-ui/core";
import { Link, useHistory } from "react-router-dom";
import { FormattedMessage, useIntl } from "react-intl";
import Login from "./Login";
import PhoneIcon from '@material-ui/icons/Phone';
import EmailIcon from '@material-ui/icons/Email';
import { useCookies } from "react-cookie";
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import "flag-icons/css/flag-icons.min.css";


const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    grow: {
      flexGrow: 0.1,
    },
    logo: {
      flexShrink: 0,
    },
    menuButton: {
      marginRight: theme.spacing(2),
    },
    search: {
      position: 'relative',
      flex: '1 1 auto',
      minWidth: 260,
      maxWidth: 760,
      marginRight: theme.spacing(3),
      marginLeft: theme.spacing(3),
      [theme.breakpoints.up('sm')]: {
        width: '100%',
      },
    },
    searchIcon: {
      padding: theme.spacing(0, 2),
      height: '100%',
      position: 'absolute',
      pointerEvents: 'none',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    inputRoot: {
      color: 'inherit',
      width: '100%',
      "& .MuiAutocomplete-inputRoot": {
        padding: "0 !important",
      },
      "& .MuiAutocomplete-input": {
        paddingLeft: `calc(1em + ${theme.spacing(4)}px) !important`,
      },
      "& .MuiOutlinedInput-root": {
        height: "44px",
        backgroundColor: "#ffffff",
        borderRadius: "4px",
      },
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: "#ebdcc4",
      },
      "&:hover .MuiOutlinedInput-notchedOutline": {
        borderColor: "#ebdcc4",
      },
      "& .Mui-focused .MuiOutlinedInput-notchedOutline": {
        borderColor: "#ebdcc4",
        borderWidth: "1px",
      },
    },
    buttonText: {
      fontSize: '14px',
      fontWeight: 'bold',
      paddingLeft: '10px',
      color: '#000000',
      textDecoration: 'none'
    },
    loginButtonText: {
      fontSize: '14px',
      fontWeight: 'bold',
      paddingLeft: '10px',
      color: "#1b598b",
      "&:hover": {
        cursor: "pointer",
        color: "#1b598b",
      },
    },
    logoutButtonText: {
      fontSize: '14px',
      fontWeight: 'bold',
      paddingLeft: '10px',
      color: "#4e342e",
      "&:hover": {
        cursor: "pointer",
        color: "#4e342e",
      },
    },
    phoneButtonText: {
      fontSize: '14px',
      fontWeight: 'bold',
      paddingLeft: '10px',
      color: "#c2062b",
      "&:hover": {
        cursor: "pointer",
        color: "#c2062b",
      },
    },
    selectText: {
      fontSize: '14px',
      fontWeight: 'bold',
      paddingTop: '3px',
      paddingLeft: '5px',
    },
    languageOption: {
      display: "flex",
      alignItems: "center",
      gap: "8px",
      fontSize: "14px",
      fontWeight: "bold",
    },
    languageFlag: {
      width: "24px",
      height: "18px",
      boxShadow: "0 3px 8px rgba(0, 0, 0, 0.25)",
    },
    inputInput: {
      width: '100%',
    },
    searchImage: {
      textAlign: "center",
    },
    searchImageDetails: {
      maxHeight: "42px",
      maxWidth: "56px",
    },
    searchContent: {
      color: "#333333",
      fontSize: "14px",
      paddingLeft: "8px",
    },
    searchLink: {
      color: "inherit",
      textDecoration: "none",
      width: "100%",
    },
    sectionDesktop: {
      display: 'none',
      flexShrink: 0,
      [theme.breakpoints.up('md')]: {
        display: 'flex',
      },
    },
    sectionMobile: {
      display: 'flex',
      [theme.breakpoints.up('md')]: {
        display: 'none',
      },
    },
    linkButton: {
      textDecoration: 'none',
      color: '#000000'
    },
  }),
);

interface PropsFromState {
  language: string;
  login: boolean;
  loading: boolean;
  user: UserData;
  profile: UserProfile;
  cart?: Cart;
  searchResults: ProductsData[];
}

interface propsFromDispatch {
  changeLanguage: (language: string) => any;
  fetchMenu: () => any;
  getStatus: (cookie: any, setCookie: any) => any;
  logoutUser: (setCookie: any) => any;
  searchText: (text: string) => any;
}

type AllProps = PropsFromState & propsFromDispatch;

const HeaderLine: React.FC<AllProps> = ({
  language,
  login,
  loading,
  user,
  profile,
  cart,
  searchResults,
  changeLanguage,
  fetchMenu,
  getStatus,
  logoutUser,
  searchText,
}) => {
  const [cookies, setCookie] = useCookies();

  useEffect(() => {
    getStatus(cookies, setCookie);
    fetchMenu();
  }, [cookies, fetchMenu, getStatus, setCookie]);

  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = React.useState<null | HTMLElement>(null);
  const [isLoginOpen, handleLogin] = useState(false);
  const [search, setSearch] = useState("");
  const [options, setOptions] = useState<ProductsData[]>([]);
  const isMenuOpen = Boolean(anchorEl);
  const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);
  const intl = useIntl();
  const userDisplayName = user?.profile?.name || intl.formatMessage({ id: "login" });
  const history = useHistory();

  useEffect(() => {
    setOptions(searchResults);
  }, [searchResults]);

  const handleMobileMenuClose = () => {
    setMobileMoreAnchorEl(null);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    handleMobileMenuClose();
  };

  const handleMobileMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setMobileMoreAnchorEl(event.currentTarget);
  };

  const popupHandler = () => {
    handleLogin(current => !current)
  }

  const logoutHandler = () => {
    logoutUser(setCookie);
    handleMobileMenuClose();
  };

  const handleLanguage = (language: string) => {
    changeLanguage(language);
  }

  const languageOptions = [
    { code: "lv", flag: "lv", label: intl.formatMessage({ id: "language.lv" }) },
    { code: "en", flag: "gb", label: intl.formatMessage({ id: "language.en" }) },
    { code: "ee", flag: "ee", label: intl.formatMessage({ id: "language.ee" }) },
    { code: "ru", flag: "ru", label: intl.formatMessage({ id: "language.ru" }) },
    { code: "de", flag: "de", label: intl.formatMessage({ id: "language.de" }) },
    { code: "lt", flag: "lt", label: intl.formatMessage({ id: "language.lt" }) },
  ];

  const renderLanguageValue = (selected: any) => {
    const selectedLanguage = languageOptions.find((option) => option.code === selected) || languageOptions[0];
    return (
      <span className={classes.languageOption}>
        <span className={`fi fi-${selectedLanguage.flag} ${classes.languageFlag}`} />
        <span>{selectedLanguage.label}</span>
      </span>
    );
  };

  const handleSearchValue = (value: string) => {
    setSearch(value);
    if (value.length > 1) {
      searchText(value);
    } else {
      setOptions([]);
    }
  };

  const handleSearchSelect = (newValue: ProductsData | null) => {
    if (!newValue) return;
    const searchType = String(newValue.searchType || "P");
    setSearch("");
    setOptions([]);
    history.push(searchType === "C" ? "/product/category/" + newValue.code : "/product/" + newValue.code);
  };

  const menuId = 'primary-search-account-menu';
  const renderMenu = (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      id={menuId}
      keepMounted
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      open={isMenuOpen}
      onClose={handleMenuClose}
    >
      <MenuItem onClick={handleMenuClose}><FormattedMessage id="profile.myAccount" /></MenuItem>
      <MenuItem onClick={handleMenuClose}><FormattedMessage id="profile.title" /></MenuItem>
    </Menu>
  );

  const mobileMenuId = 'primary-search-account-menu-mobile';
  const renderMobileMenu = (
    <Menu
      anchorEl={mobileMoreAnchorEl}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      id={mobileMenuId}
      keepMounted
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      open={isMobileMenuOpen}
      onClose={handleMobileMenuClose}
    >


<Hidden>
      <MenuItem>{login ?
        <Link to="/profile" className={classes.linkButton}>
          <IconButton
            edge="end"
            aria-label={intl.formatMessage({ id: "aria.userAccount" })}
            aria-controls={menuId}
            aria-haspopup="true"
            color="inherit"
          >
            <AccountCircle />
            <div className={classes.buttonText}>
              {userDisplayName}
            </div>
          </IconButton>
        </Link>
        : null}
        {login ?
          <IconButton
            edge="end"
            aria-label={intl.formatMessage({ id: "logout" })}
            onClick={logoutHandler}
            color="inherit"
          >
            <ExitToAppIcon />
            <div className={classes.buttonText}>
              <FormattedMessage id="logout" />
            </div>
          </IconButton>
          : null}


        {!login ?
          <IconButton
            edge="end"
            aria-label={intl.formatMessage({ id: "aria.userAccount" })}
            aria-haspopup="true"
            onClick={popupHandler}
            color="inherit"
          >
            <AccountCircle />
            <div className={classes.buttonText}>
            <FormattedMessage id="login" />
              </div>
          </IconButton>
          : null}
          
      </MenuItem>
          </Hidden>
      <MenuItem>
        <Link to="/cart" className={classes.linkButton}>
          <IconButton aria-label={intl.formatMessage({ id: "aria.shoppingCart" })} color="inherit" onClick={handleMobileMenuClose}>
            <Badge badgeContent={cart?.count || 0} color="secondary">
              <ShoppingCartIcon />
            </Badge>
            <div className={classes.buttonText}><FormattedMessage id="cart" /></div>
          </IconButton>
        </Link>
      </MenuItem>
      <MenuItem>
        <Select
          disableUnderline
          className={classes.selectText}
          value={language}
          onChange={(event: any) => handleLanguage(event.target.value)}
          renderValue={renderLanguageValue}
        >
          {languageOptions.map((option) => (
            <MenuItem key={option.code} value={option.code}>
              <span className={classes.languageOption}>
                <span className={`fi fi-${option.flag} ${classes.languageFlag}`} />
                <span>{option.label}</span>
              </span>
            </MenuItem>
          ))}
        </Select>
      </MenuItem>
    </Menu>
  );

  return (
    <>
      <AppBar color="primary" position="static">
        <Login isLoginOpen={isLoginOpen} closeHandler={popupHandler} />
        <Toolbar>
          <Link to="/" className={classes.logo}>
            <Box><img src="/images/logo.png" height="64px" alt={intl.formatMessage({ id: "image.logoAlt" })} /></Box></Link>
          <div className={classes.search}>
            <div className={classes.searchIcon}>
              <SearchIcon />
            </div>
            <Autocomplete
              id="header-product-search"
              className={classes.inputRoot}
              options={options}
              autoComplete
              includeInputInList
              forcePopupIcon={false}
              open={search.length > 1 && options.length > 0}
              noOptionsText={null}
              filterSelectedOptions
              inputValue={search}
              onInputChange={(event, value, reason) => {
                if (reason === "clear") {
                  setSearch("");
                  setOptions([]);
                  return;
                }
                if (reason === "input") {
                  handleSearchValue(value);
                }
              }}
              onChange={(event: any, newValue: ProductsData | null) => handleSearchSelect(newValue)}
              getOptionLabel={(option) => option?.title?.[language] || option?.title?.lv || ""}
              renderOption={(option) => {
                const searchType = String(option.searchType || "P");
                const imagePath = searchType === "C" ? "/files/menu_pictures/" : "/files/product_images/";
                const imageName = option?.image?.[0]?.img || "";
                const title = option?.title?.[language] || option?.title?.lv || "";
                return (
                  <Link
                    to={searchType === "C" ? "/product/category/" + option?.code : "/product/" + option?.code}
                    className={classes.searchLink}
                  >
                    <Grid container alignItems="center">
                      <Grid item xs={3} className={classes.searchImage}>
                        {imageName ? (
                          <img
                            src={process.env.REACT_APP_IMAGE_HOST + imagePath + imageName}
                            alt={option?.image?.[0]?.description || title}
                            className={classes.searchImageDetails}
                          />
                        ) : null}
                      </Grid>
                      <Grid item xs={9} className={classes.searchContent}>
                        {title}
                      </Grid>
                    </Grid>
                  </Link>
                );
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  className={classes.inputInput}
                  fullWidth
                  placeholder={intl.formatMessage({ id: "search.placeholder" })}
                  inputProps={{
                    ...params.inputProps,
                    "aria-label": intl.formatMessage({ id: "search.placeholder" }),
                  }}
                />
              )}
            />
          </div>
          <div className={classes.grow} />
          <div className={classes.sectionDesktop}>
              <IconButton
                component="a"
                href="tel:+37129236283"
                edge="end"
                aria-label={intl.formatMessage({ id: "aria.phone" })}
                aria-haspopup="true"
                className={classes.phoneButtonText}
              >
                <PhoneIcon />
                <div className={classes.buttonText}>
                +371 29236283
              </div>
              </IconButton>
              <IconButton
                edge="end"
                aria-label={intl.formatMessage({ id: "aria.email" })}
                aria-haspopup="true"
                className={classes.phoneButtonText}
              >
                <EmailIcon />
                <div >
                <a className={classes.buttonText} href="&#x6d;&#x61;&#x69;&#x6c;&#x74;&#x6f;&#x3a;&#x72;&#x65;&#x74;&#x72;&#x6f;&#x40;&#x62;&#x70;&#x67;&#x72;&#x6f;&#x75;&#x70;&#x2e;&#x6c;&#x76;">&#x72;&#x65;&#x74;&#x72;&#x6f;&#x40;&#x62;&#x70;&#x67;&#x72;&#x6f;&#x75;&#x70;&#x2e;&#x6c;&#x76;</a>
              </div>
              </IconButton>
              {login ? (
                <>
                <Link to="/profile" className={classes.linkButton}>
                  <IconButton
                    edge="end"
                    aria-label={intl.formatMessage({ id: "aria.userAccount" })}
                    aria-controls={menuId}
                    aria-haspopup="true"
                    className={classes.loginButtonText}
                  >
                    <AccountCircle />
                    <div className={classes.buttonText}>
                      {userDisplayName}
                    </div>
                  </IconButton>
                </Link>
                <IconButton
                  edge="end"
                  aria-label={intl.formatMessage({ id: "logout" })}
                  onClick={logoutHandler}
                  className={classes.logoutButtonText}
                >
                  <ExitToAppIcon />
                  <div className={classes.buttonText}>
                    <FormattedMessage id="logout" />
                  </div>
                </IconButton>
                </>
              ) : (
                <IconButton
                  edge="end"
                  aria-label={intl.formatMessage({ id: "login" })}
                  aria-haspopup="true"
                  onClick={popupHandler}
                  className={classes.loginButtonText}
                >
                  <AccountCircle />
                  <div className={classes.buttonText}>
                    <FormattedMessage id="login" />
                  </div>
                </IconButton>
              )}
              <Hidden smUp>
            {login ?
              <>
              <Link to="/profile" className={classes.loginButtonText}>
                <IconButton
                  edge="end"
                  aria-label={intl.formatMessage({ id: "aria.userAccount" })}
                  aria-controls={menuId}
                  aria-haspopup="true"
                  className={classes.loginButtonText}
                >
                  <AccountCircle />
                  <div className={classes.buttonText}>
                    {userDisplayName}
                  </div>
                </IconButton>
              </Link>
              <IconButton
                edge="end"
                aria-label={intl.formatMessage({ id: "logout" })}
                onClick={logoutHandler}
                color="inherit"
                className={classes.logoutButtonText}
              >
                <ExitToAppIcon />
                <div className={classes.buttonText}>
                  <FormattedMessage id="logout" />
                </div>
              </IconButton>
              </>
              : null}
            {!login ?
              <IconButton
                edge="end"
                aria-label={intl.formatMessage({ id: "aria.userAccount" })}
                aria-haspopup="true"
                onClick={popupHandler}
                color="inherit"
                className={classes.loginButtonText}
              >
                <AccountCircle />
                <div className={classes.buttonText}>
            <FormattedMessage id="login" />
              </div>
              </IconButton>
              : null}
              </Hidden>
            <Link to="/cart" className={classes.linkButton}>
              <IconButton aria-label={intl.formatMessage({ id: "aria.shoppingCart" })} color="inherit">
                <Badge badgeContent={cart?.count} color="secondary">
                  <ShoppingCartIcon />
                </Badge>
                <div className={classes.buttonText}>
                  <FormattedMessage id="cart" />
              </div>
              </IconButton>
            </Link>
            <Select
              disableUnderline
              className={classes.selectText}
              value={language}
              onChange={(event: any) => handleLanguage(event.target.value)}
              renderValue={renderLanguageValue}
            >
              {languageOptions.map((option) => (
                <MenuItem key={option.code} value={option.code}>
                  <span className={classes.languageOption}>
                    <span className={`fi fi-${option.flag} ${classes.languageFlag}`} />
                    <span>{option.label}</span>
                  </span>
                </MenuItem>
              ))}
            </Select>
          </div>
          <div className={classes.sectionMobile}>
            <IconButton
              aria-label={intl.formatMessage({ id: "aria.showMore" })}
              aria-controls={mobileMenuId}
              aria-haspopup="true"
              onClick={handleMobileMenuOpen}
              color="inherit"
            >
              <MoreIcon />
            </IconButton>
          </div>
        </Toolbar>
      </AppBar>
      {renderMobileMenu}
      {renderMenu}
    </>
  );
};

const mapStateToProps = ({ language, user, products }: ApplicationState) => ({
  language: language.language,
  login: user.login,
  loading: user.loading,
  user: user.user,
  profile: user.profile,
  cart: user.cart,
  searchResults: products.searchResults,
});

const mapDispatchToProps = (dispatch: ThunkDispatch<any, any, AnyAction>) => {
  return {
    fetchMenu: () => {
      dispatch(fetchMenu());
    },
    changeLanguage: (language: string) => {
      dispatch(changeLanguage(language));
    },
    getStatus: (cookie: any, setCookie: any) => {
      dispatch(getStatus(cookie, setCookie));
    },
    logoutUser: (setCookie: any) => {
      dispatch(logoutUser(setCookie));
    },
    searchText: (text: string) => {
      dispatch(searchText(text));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(HeaderLine);
